import React from 'react';

export const registrationIconSvg = (
  value: boolean,
  selected: string,
  disabled: string
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    viewBox="0 0 42.811 58.336"
    id="iconMenu-icon-registration">
    <g transform="translate(2 2)">
      <g transform="translate(38.811 0) rotate(90)">
        <path
          d="M0,17.525a2,2,0,0,1-2-2V0A2,2,0,0,1,0-2,2,2,0,0,1,2,0V15.525A2,2,0,0,1,0,17.525Z"
          transform="translate(7.762 23.287)"
          fill={value ? selected : disabled}
        />
        <path
          d="M0,13.643a2,2,0,0,1-2-2V0A2,2,0,0,1,0-2,2,2,0,0,1,2,0V11.643A2,2,0,0,1,0,13.643Z"
          transform="translate(7.762 0)"
          fill={value ? selected : disabled}
        />
        <path
          d="M0,19.324a2,2,0,0,1-2-2V0A2,2,0,0,1,0-2,2,2,0,0,1,2,0V17.324A2,2,0,0,1,0,19.324Z"
          transform="translate(27.766 21.138)"
          fill={value ? selected : disabled}
        />
        <path
          d="M0,13.643a2,2,0,0,1-2-2V0A2,2,0,0,1,0-2,2,2,0,0,1,2,0V11.643A2,2,0,0,1,0,13.643Z"
          transform="translate(27.168 0)"
          fill={value ? selected : disabled}
        />
        <path
          d="M0,13.643a2,2,0,0,1-2-2V0A2,2,0,0,1,0-2,2,2,0,0,1,2,0V11.643A2,2,0,0,1,0,13.643Z"
          transform="translate(46.574 27.168)"
          fill={value ? selected : disabled}
        />
        <path
          d="M0,17.525a2,2,0,0,1-2-2V0A2,2,0,0,1,0-2,2,2,0,0,1,2,0V15.525A2,2,0,0,1,0,17.525Z"
          transform="translate(46.574 0)"
          fill={value ? selected : disabled}
        />
        <path
          d="M15.524,2H0A2,2,0,0,1-2,0,2,2,0,0,1,0-2H15.524a2,2,0,0,1,2,2A2,2,0,0,1,15.524,2Z"
          transform="translate(0 23.287)"
          fill={value ? selected : disabled}
        />
        <path
          d="M15.524,2H0A2,2,0,0,1-2,0,2,2,0,0,1,0-2H15.524a2,2,0,0,1,2,2A2,2,0,0,1,15.524,2Z"
          transform="translate(19.406 11.643)"
          fill={value ? selected : disabled}
        />
        <path
          d="M15.524,2H0A2,2,0,0,1-2,0,2,2,0,0,1,0-2H15.524a2,2,0,0,1,2,2A2,2,0,0,1,15.524,2Z"
          transform="translate(38.811 27.168)"
          fill={value ? selected : disabled}
        />
      </g>
    </g>
  </svg>
);
